exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tab-content[data-v-7c428acb] {\n  width: 100%;\n  height: 100%;\n  background: var(--v-secondary-lighten1);\n  overflow: auto;\n}\n", "", {"version":3,"sources":["/app/src/components/Home/Content/Tabs/Validations/ValidationsTab.vue"],"names":[],"mappings":";AAgEA;EACE,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,eAAe;CAChB","file":"ValidationsTab.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.tab-content {\n  width: 100%;\n  height: 100%;\n  background: var(--v-secondary-lighten1);\n  overflow: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c428acb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Content/Tabs/Validations/ValidationsTab.vue
// module id = r1Q6
// module chunks = 0